<script setup lang="ts">
import AppHeader from './AppHeader.vue'
import AppSidebar from './AppSidebar.vue'
</script>

<template>
  <div class="app-shell">
    <AppHeader class="app-shell__header" />
    <div class="app-shell__body">
      <AppSidebar class="app-shell__sidebar" />
      <main class="app-shell__main">
        <div class="app-shell__content">
          <router-view />
        </div>
      </main>
    </div>
  </div>
</template>

<style scoped lang="scss">
.app-shell {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;

  &__header {
    flex-shrink: 0;
    height: 56px;
    z-index: 100;
  }

  &__body {
    display: flex;
    flex: 1;
    overflow: hidden;
  }

  &__sidebar {
    flex-shrink: 0;
    width: 220px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  &__main {
    flex: 1;
    overflow: auto;
    background-color: var(--aw-bg-subtle);
  }

  &__content {
    max-width: 1440px;
    margin: 0 auto;
    padding: var(--aw-space-6);
    min-height: 100%;
  }
}
</style>
